import React from 'react';
import App from './App';
import ReactDOM from 'react-dom';
import * as serviceWorker from './serviceWorker';

import { Provider } from 'react-redux';

import { ThemeProvider } from '@material-ui/core/styles';
import theme from './theme';

import { PublicClientApplication, EventType } from '@azure/msal-browser';
import { msalConfig } from './config';

import { configureStore } from '@reduxjs/toolkit';
import { marketingApi } from './apis/backend';
import chainSiteReducer from './slices/chainSiteSelector';

export const msalInstance = new PublicClientApplication(msalConfig);


const store = configureStore({
  reducer: {
    [marketingApi.reducerPath]: marketingApi.reducer,
    doris: chainSiteReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(marketingApi.middleware)
});

const accounts = msalInstance.getAllAccounts();
if (accounts.length) {
  msalInstance.setActiveAccount(accounts[0]);
}

msalInstance.addEventCallback(event => {
  if (event.eventType === EventType.LOGIN_SUCCESS && event.payload.account) {
    const account = event.payload.account;
    msalInstance.setActiveAccount(account);
  }
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <App pca={msalInstance} />
      </ThemeProvider>
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

serviceWorker.unregister();
